import { render } from "./ExcerciseTest.vue?vue&type=template&id=b813c5c6&scoped=true"
import script from "./ExcerciseTest.vue?vue&type=script&lang=js"
export * from "./ExcerciseTest.vue?vue&type=script&lang=js"

import "./ExcerciseTest.vue?vue&type=style&index=0&id=b813c5c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b813c5c6"]])

export default __exports__